import api from './api';

export interface I18nGapRecord {
  key: string;
  ns: string;
  language: string;
  firstSeenAt: string;
  lastSeenAt: string;
  hitCount: number;
}

export const i18nGapsService = {
  list: async () => {
    const res = await api.get('/i18n-gaps');
    return {
      items: res.data.data as I18nGapRecord[],
      total: res.data.meta.total as number,
    };
  },
};
